/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate200,
  GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate401,
  GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate403,
  GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate404,
  GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate500,
  GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificatePathParams,
  GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificateQueryResponse,
} from "../../types/documentCourseRegistrationController/GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate.ts";

export const getApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificatePathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificatePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate200Schema =
  z.instanceof(
    File,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate401>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate403Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate403>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate500>;

export const getApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificateQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificate200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidFinishCourseCertificateQueryResponse>;
